import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Typography, Input, DatePicker, Modal, Button, Menu, message, Row, Space } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { CloseCircleOutlined, PlusOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import NewTable from "./components/NewTable";
import DetailModal from "./components/DetailModal";
import './css/TableTitle.css'
const { RangePicker } = DatePicker;
const SearchStudentList = () => {
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [search_date, set_search_date] = useState([])
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [custom_column, set_custom_column] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState();
    const [people, setPeople] = useState(null);
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [data, setData] = useState([]);
    const [editcard, setEditCard] = useState({});
    const [choose_column, set_choose_column] = useState([]);
    const { confirm } = Modal;
    const [messageApi, contextHolder] = message.useMessage();
    const [datas, setDatas] = useState([])
    const navigate = useNavigate();
    const [default_column, set_default_column] = useState([{
        title: '姓名',
        key: 'client',
        dataIndex: 'client',
        align: 'center'
    },
    {
        title: '學生電話',
        key: 'phone',
        dataIndex: 'phone',
        align: 'center'

    },
    {
        title: '就讀學校',
        key: 'school',
        dataIndex: 'school',
        align: 'center'
    },
    {
        title: '現今年級',
        key: 'grade_name',
        dataIndex: 'grade_name',
        align: 'center'
    },
    {
        title: '電子信箱',
        key: 'e_mail',
        dataIndex: 'e_mail',
        align: 'center'
    },
    {
        title: '在校成績',
        key: 'school_score',
        dataIndex: 'school_score',
        align: 'center'
    },
    {
        title: '學習英文時長',
        key: 'learn_english_year_name',
        dataIndex: 'learn_english_year_name',
        align: 'center'
    },
    {
        title: '檢定名稱',
        key: 'test_name',
        dataIndex: 'test_name',
        align: 'center'
    },
    {
        title: '詢問問題',
        key: 'question',
        dataIndex: 'question',
        align: 'center'
    },
    {
        title: '諮詢時間',
        key: 'first_insert_time',
        dataIndex: 'first_insert_time',
        align: 'center'
    },
    {
        title: '想諮詢諮詢班級',
        key: 'class_name',
        dataIndex: 'class_name',
        align: 'center'
    },
    {
        title: '是否成為學員',
        align: 'center',
        render: (text, record, index) => {
            if (record.is_student == false) {
                return (
                    <>
                        <Button type="primary"
                            onClick={e => handleStudent(record.contact_id, record.client, record.phone, record.school, record.e_mail, record.grade_id)}
                        >成為學員</Button>
                    </>
                )
            } else {
                return (<>已為學生</>)
            }

        }
    },
    {
        title: '操作',
        sorter: false,
        align: 'center',
        render: (text, record, index) => (
            <>
                <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEditRow(record)}>編輯</Button>
                <Button type="text" style={{ color: 'red' }} onClick={(e) => showMessage(record.contact_id)}>刪除</Button>
            </>
        )
    },
    ])
    const handleStudent = (id, name, phone, school, email, grade_id) => {
        let data_tmp = {};
        data_tmp['id'] = id;
        data_tmp['name'] = name;
        data_tmp['phone'] = phone;
        data_tmp['school'] = school;
        data_tmp['email'] = email;
        data_tmp['grade_id'] = grade_id;
        // console.log(data_tmp)
        axios
            .post('/cramSchool/api/admin/contact/export_student', [data_tmp])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                }
            })
    }
    const handleEdit = () => {
        axios
            .patch(`/cramSchool/api/admin/contact`, [{ ...editcard }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    reload();
                }
            })
    }
    const handleSubmit = () => {
        if (editcard.client == undefined || editcard.school == undefined || editcard.phone == undefined || editcard.grade_id == undefined || editcard.school_score == undefined || editcard.client == '' || editcard.school == '' || editcard.phone == '' || editcard.grade_id == '' || editcard.school_score == '') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '請完整填寫必填欄位',
            });
        } else {

            axios
                .post(`/cramSchool/api/admin/contact`, [{ ...editcard }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        reload();
                    }
                })
        }
        // console.log(editcard);
    }
    const getData = (param, sort, filter, checklist) => {
        set_loading(true);
        axios
            .get('/cramSchool/api/admin/contact', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    first_insert_time: search_date[0] && [search_date[0], search_date[1]],
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
                setPeople(response.data.people);
            })
            .finally((error) => {
                set_loading(false)
            })

    }
    useEffect(() => {
        getData();
    }, [])
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleOnDelete(value);
            },
            centered: true
        });
    };
    const handleOnDelete = (value) => {
        axios
            .delete(`/cramSchool/api/admin/contact`, {
                data: [{ 'contact_id': value }]
            })
            .then((response) => {
                if (response.data.status != 'success') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    reload();
                }
            })
    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value, i) => {
                deleterow.push({ 'contact_id': value })
            })
            axios
                .delete(`/cramSchool/api/admin/contact`, {
                    data: deleterow
                })
                .then((response) => {
                    // console.log(response)
                    if (response.data.status != 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                })
        }
    }
    const handleOnEditRow = (record) => {
        console.log(record)
        setTitle('修改名單');
        setColor('f09a45');
        setEdit(true);
        setOpen(true);
        setEditCard(record);
    }

    const handleOnAddRow = () => {
        setTitle('新增名單');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setData(null);
        setEditCard({});
    }
    useEffect(() => {
        reload()
    }, [search_date])
    const handleSearchDate = (date) => {
        set_search_date(date);
    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'contact',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'contact'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }

    return (
        <>
            {contextHolder}
            <DetailModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                setData={setData}
                editcard={editcard}
                setEditCard={setEditCard}
                data={data}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
            />
            <Row align={'end'} style={{ paddingTop: '10px' }}>
                <Col>諮詢學生總人數：{people}人</Col>
                <Col span={24} >
                    <NewTable
                        total={total}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        loading={loading}
                        page_name={'SearchStudentList'}
                        force_reload={force_reload}
                        columns={default_column.concat(extra_columns || [])}
                        getData={getData}
                        datas={datas}//table資料
                        add_button_title={'新增名單'}//新增按鈕上的名稱
                        custom_column={custom_column}//table 客製化欄位
                        handleOnAddRow={handleOnAddRow}//新增row 內容
                        rowkey={'contact_id'}//key
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                        handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        rangepicker_title={'諮詢時間'}
                        handleSearchDate={handleSearchDate}//搜尋日期
                    ></NewTable>
                </Col>
            </Row>
        </>

    );
};
export default SearchStudentList;
